import Address from "typedef/Address";
import { FC } from "react";
import { Autocomplete } from "@mui/material";
import CTextField, { CTextFieldProps } from "components/CTextField";
import addressToString from "./addressToString";
import useAddressAutoComplete from "./useAddressAutocomplete";
import color from "context/MaterialUITheme/color";

export type CAddressAutocompleteProps = CTextFieldProps & {
  address?: Address | null;
  setAddress(address: Address | null): void;
  noLabel?: boolean;
};

const CAddressAutocomplete: FC<CAddressAutocompleteProps> = ({
  address,
  setAddress,
  noLabel,
  ...props
}) => {
  const addressAutocomplete = useAddressAutoComplete({ address, setAddress });

  return (
    <Autocomplete
      placeholder="Please enter your home address"
      open={addressAutocomplete.open}
      color="primary"
      value={address}
      clearOnBlur
      loading={addressAutocomplete.loading}
      options={addressAutocomplete.options}
      inputValue={addressAutocomplete.text}
      onChange={addressAutocomplete.handleOnChange}
      onInputChange={addressAutocomplete.handleOnInputChange}
      onOpen={addressAutocomplete.handleOnOpen}
      onClose={addressAutocomplete.handleOnClose}
      getOptionLabel={addressToString}
      isOptionEqualToValue={(option, value) =>
        option.street_line === value.street_line
      }
      popupIcon={false}
      noOptionsText={"Please enter your home address"}
      renderInput={(params) => (
        <CTextField
          {...props}
          {...params}
          placeholder={props.placeholder}
          label={noLabel ? undefined : props.label}
          InputLabelProps={{ shrink: true }}
          InputProps={{
            ...params.InputProps,
            ...props.InputProps,
          }}
          fullWidth
        />
      )}
      sx={{
        "& .MuiOutlinedInput-root": {
          color: color.black,
        },
        "& .MuiAutocomplete-listbox": {
          color: color.white,
        },
      }}
    />
  );
};

export default CAddressAutocomplete;
